export default "__VITE_ASSET__BY6SIIk8__"